exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-results-found {\n  width: 100%;\n  margin: 0 auto;\n  text-align: center; }\n  .no-results-found img {\n    width: 150px;\n    animation: scaleLoop 3s infinite ease-in-out; }\n\n@keyframes scaleLoop {\n  0% {\n    transform: scale(1, 1); }\n  40% {\n    transform: scale(1, 1); }\n  45% {\n    transform: scale(1.1, 1.1); }\n  50% {\n    transform: scale(1, 1); }\n  55% {\n    transform: scale(1.1, 1.1); }\n  60% {\n    transform: scale(1, 1); }\n  100% {\n    transform: scale(1, 1); } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/main/no-results-found/no-results-found.scss
// module id = 663
// module chunks = 0